// Initials-based avatars. The dashboard previously pulled placeholder faces
// from an external service; real people get their initials instead, which
// needs no network request and never shows a stranger's photo.
export const initials = (name) => {
  const parts = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) return '?';
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

// Deterministic tone index (0-5) so the same person keeps the same colour
// across renders and across cards.
export const avatarTone = (name) => {
  const s = String(name || '');
  let h = 0;
  for (let i = 0; i < s.length; i += 1) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return h % 6;
};
